import React, { useEffect, useState } from "react";
import { Button, Card, fabClasses } from "@mui/material";
import Box from "@mui/material/Box";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Modal from "@mui/material/Modal";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import GetDetailsAns from "./getDetailsAns";
import _ from "lodash";
import { onboardingServices } from "../../services/onboardingServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { getFileNameByPath, isEmptyDash } from "../../constant";
import ConfirmModal from "../common/confirmModal";
import { UserObj } from "../../services/localStarage";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PreviewDoc from "../common/previewDoc";
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "block",
  marginTop: "5rem",
  width: "50%",
};

function TechnicalComplianceStep3({ data, viewUrlData, changeScreen, vendorId }) {
  const [technicalopen, setTechnicalOpen] = React.useState(false);
  const handleOpen = () => setTechnicalOpen(true);
  const handleClose = () => setTechnicalOpen(false);
  const [checklistArr, setChecklistArr] = React.useState([]);
  const [technicalData, setTechnicalData] = React.useState({
    fieldsWithResponses: [],
  });

  const [openfactorytodotModal, setOpenFactoryTodoModal] = useState(false);
  const [selectedFiled, setSelectedFile] = useState([]);
  const [files, setFiles] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditModal, setIsEditModal] = React.useState(false);
  const [modalData, setModalData] = React.useState({ fields: [] });
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [uploadObj, setUploadObj] = React.useState({
    param: false,
    i: 0,
    row: { response: { files: [] } },
    j: 0,
  });
  // const [selectedFiled, setSelectedFile] = useState([]);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isParamsDataSet, setIsParamDataSet] = useState();
  let roleName = UserObj?.role.name;

  const openConrimModdal = (paramData) => {
    let modalDataInit = _.cloneDeep(modalData);
    let isValid = true;

    for (let i = 0; i < modalDataInit?.fields.length; i++) {
      if (
        modalDataInit?.fields[i].required == true &&
        isEmptyDash(modalDataInit?.fields[i].response.files)
      ) {
        isValid = false;
      } else if (
        modalDataInit?.fields[i].required == true &&
        modalDataInit?.fields[i].response.files.length < 1
      ) {
        isValid = false;
      }
    }

    if (isValid) {
      setIsConfirmModalOpen(true);
      setIsParamDataSet(paramData);
    } else {
      openAlert(true, "error", `Please fill out all required fields.`);
    }
  };
  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const successConfirmModal = (param) => {
    submitData(isParamsDataSet);
  };
  const addFile = (e) => {
    e.preventDefault();
    let fileData = e.target.files[0];
    setFiles(fileData);
  };

  const deleteFile = (ele, index) => {
    let uploadObjInit = _.cloneDeep(uploadObj);
    let modalDataInit = _.cloneDeep(modalData);

    let modalDataInitFiles =
      modalDataInit.fields[uploadObjInit?.j].response.files;
    let uploadObjInitFiles = uploadObjInit.row.response.files;

    let newModalDataInitFiles = modalDataInitFiles.filter(
      (ele, i) => i != index
    );
    let newUploadObjInitFiles = uploadObjInitFiles.filter(
      (ele, i) => i != index
    );

    modalDataInit.fields[uploadObjInit?.j].response.files = [
      ...newModalDataInitFiles,
    ];
    uploadObjInit.row.response.files = [...newUploadObjInitFiles];

    setUploadObj(uploadObjInit);
    setModalData(modalDataInit);
    // const updatedFiles = uploadObjInit?.row?.response?.files.filter((file, i) => i !== index);
    // setUploadObj(uploadObjInit);
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleCloseLoader = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const uploadFile = (e) => {
    e.preventDefault();
    if (isEmptyDash(files)) {
      openAlert(true, "error", `Please select a file.`);
      return;
    }
    let formData = new FormData();
    formData.append("file", files);

    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success == true) {
          addFileInList(response?.data?.data, files);
          openAlert(true, "success", `${response?.data?.message}`);
          setFiles(null);
          document.getElementById("checklist-fileInput").value = null;
          // setUrl(response?.data?.data);

          // formStepFieldsDetailsInitial[i].answer = e.target.value;
          // setFormStepFieldsDetails(formStepFieldsDetailsInitial);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const addFileInList = (data, files) => {
    let uploadObjInit = _.cloneDeep(uploadObj);
    let modalDataInit = _.cloneDeep(modalData);
    // let checklistArrInit = _.cloneDeep(checklistArr);

    let obj = {
      key: data?.data?.key,
      name: files?.name,
    };

    if (isEmptyDash(uploadObjInit?.row?.response.files)) {
      modalDataInit.fields[uploadObjInit?.j].response.files = [obj];
      uploadObjInit.row.response.files = [obj];
      // checklistArrInit[uploadObj?.i].fields[uploadObj?.j].response.files = [
      //   obj,
      // ];
    } else {
      modalDataInit.fields[uploadObjInit?.j].response.files.push(obj);
      uploadObjInit?.row?.response.files.push(obj);
      // checklistArrInit[uploadObj?.i].fields[uploadObj?.j].response.files.push(
      //   obj
      // );
    }

    // setChecklistArr(checklistArrInit);
    setUploadObj(uploadObjInit);
    setModalData(modalDataInit);
  };

  useEffect(() => {
    setChecklistArr(data?.fieldsWithResponses);
  }, [data?.fieldsWithResponses]);

  useEffect(() => {
    setTechnicalData(data);
  }, [data]);

  const viewMedia = (data) => {
    viewUrlData(data);
  };

  const openEditModal = (ele, index) => {
    let obj = { ...ele };
    obj.index = index;
    setModalData(obj);
    setIsEditModal(true);
  };

  const handleCloseModal = () => {
    setIsEditModal(false);
    setModalData({ fields: [] });
  };

  const onSelectChange = (value, ele, i, row, j) => {
    // let { value } = e.target;
    let modalDataInit = _.cloneDeep(modalData);
    modalDataInit.fields[j].response.optionId = value;
    setModalData(modalDataInit);
  };

  const onTextChange = (value, ele, i, row, j) => {
    // let { value } = e.target;
    let modalDataInit = _.cloneDeep(modalData);
    modalDataInit.fields[j].response.answer = value;
    setModalData(modalDataInit);
  };

  const openUploadModal = (param, i, row, j) => {
    // let {value} = e.target;
    let obj = { param, i, row, j };
    setUploadObj(obj);
    setOpenFactoryTodoModal(true);
    // let checklistArrInit = _.cloneDeep(checklistArr);
    // checklistArrInit[i].fields[j].response.answer = value;
    // setChecklistArr(checklistArrInit); 
  };

  const closeUploadModal = (param, i, row, j) => {
    let obj = { param: false, i: 0, row: { response: { files: [] } }, j: 0 };
    setUploadObj(obj);
    setOpenFactoryTodoModal(false);
  };

  const submitData = (param) => {
    let checklistArrInit = _.cloneDeep(checklistArr);
    let modalDataInit = _.cloneDeep(modalData);

    let obj = {
      vendorId: vendorId,
      isSubmitting: param,
      checklistData: {
        title: modalDataInit?.sectionName,
        _id: modalDataInit?.sectionId,
        fields: [],
      },
    };

    for (let j = 0; j < modalDataInit?.fields.length; j++) {
      let childObj = {
        _id: modalDataInit?.fields[j]?._id,
        files: isEmptyDash(modalDataInit?.fields[j]?.response?.files)
          ? []
          : modalDataInit?.fields[j]?.response?.files,
        answer: isEmptyDash(modalDataInit?.fields[j]?.response?.answer)
          ? ""
          : modalDataInit?.fields[j]?.response?.answer,
        optionId: isEmptyDash(modalDataInit?.fields[j]?.response?.optionId)
          ? ""
          : modalDataInit?.fields[j]?.response?.optionId,
        questionId: modalDataInit?.fields[j]?._id,
      };
      obj.checklistData.fields.push(childObj);
    }
    setIsLoading(true);
    onboardingServices
      .submitCheckListForm(obj)
      .then(function (response) {
        if (response?.data?.success == true) {
          openAlert(true, "success", `${response?.data?.message}`);
          window.location.reload();
          setTechnicalOpen(false);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
        setTechnicalOpen(false);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const rolesWithPermissions = ['SR_QUALITY', 'JR_QUALITY', 'ENGINEER'];
  return (
    <>
      <div className="llets_vendor_detailreact_11">
        <div className="text-centers_react ">
          {technicalData?.fieldsWithResponses.map((ele, i) => (
            <>
              {ele?.isModal == false && (
                <>
                  <h5 className="vendor-details-sec-head">
                    {ele?.sectionName}
                  </h5>
                  <Card className="vendor-details-card" style={{ marginBottom: '20px' }}>
                    <div className="">
                      <div className="row ">
                        {ele?.fields.map((childEle, j) => (
                          <>
                            {childEle?.display == true && (
                              <div className="col-sm-6">
                                <div className="row vendor-details-ele-row">
                                  <div className="col-sm-5">
                                    <h6 className="name_information_business_vendor_listing">
                                      {childEle?.name}:
                                    </h6>
                                  </div>
                                  <div className="col-sm-7 text-secondary lets_Technology_vendorlist">

                                    <GetDetailsAns
                                      data={childEle}
                                      viewMedia={viewMedia}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  </Card>
                </>
              )}
              {(roleName !== "VENDOR" && ele?.isModal == true) && (
                <>
                  <div className="div-details-modal-btn">
                    <button className="" onClick={() => openEditModal(ele, i)}>
                      {ele?.sectionName}
                    </button>
                    {(i == technicalData?.fieldsWithResponses?.length - 1) && <button className="div-details-modal-btn" onClick={() => changeScreen(true)}>
                      View Progress
                    </button>}
                  </div>
                </>
              )}
            </>
          ))}
        </div>


        <Modal
          open={isEditModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style1} className="modal_react_controlpanel_employeese">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                {modalData?.sectionName}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                fdprocessedid="kum8iho"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div class="modal-body checklist-body-overflow">
              <TableContainer
                className="react-bootstrap-technical2"
                component={Paper}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <p className="lets_checklist_simple_react mb-0">
                          Checklist{" "}
                        </p>
                      </TableCell>
                      <TableCell align="right">
                        <p className="lets_checklist_simple_react mb-0">
                          No. of Documents
                        </p>
                      </TableCell>
                      <TableCell align="right">
                        <p className="lets_checklist_simple_react mb-0">
                          Files
                        </p>
                      </TableCell>
                      <TableCell align="right">
                        <p className="lets_checklist_simple_react mb-0">
                          Status{" "}
                        </p>
                      </TableCell>
                      <TableCell
                        className="lets_checklist_simple_react"
                        align="right"
                      >
                        <p className="lets_checklist_simple_react mb-0">
                          {" "}
                          Remarks
                        </p>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {modalData?.fields.map((row, j) => (
                      <TableRow
                        key={row.name}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell className="lets_block_body_onboarding">
                          {row.name}
                        </TableCell>
                        <TableCell align="center">
                          {isEmptyDash(row?.response?.files)
                            ? 0
                            : row?.response?.files.length}
                        </TableCell>
                        <TableCell align="left">
                          {/* <img
                                        src={pdfImage}
                                        alt=""
                                        className="table_cell_react_support_web_vist"
                                      /> */}
                          {/* {row.fat} */}

                          {row?.isCopied == true && (
                            <button
                              className="file-upload-btn btn-success"
                              onClick={(e) => openUploadModal(false, 0, row, j)}

                            >
                              View
                            </button>
                          )}

                          {row?.isCopied == false && (
                            <button
                              className="file-upload-btn"
                              onClick={(e) => openUploadModal(true, 0, row, j)}
                              style={{ 'marginLeft': "0.5rem " }}
                            >
                              {row?.editAccess === false ? 'View' : 'Upload'}
                            </button>
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {/* {(row?.isCopied == true) && <div>
                                            {row?.response?.optionId}
                                          </div>} */}

                          {true && (
                            <select
                              className="form-select checklist-table-list-status-column"
                              onChange={(e) =>
                                onSelectChange(e.target.value, {}, 0, row, j)
                              }
                              value={row?.response?.optionId}
                              disabled={row?.editAccess == false}
                            >
                              <option
                                className="leta_react_bloxck_details"
                                value=""
                              >
                                Select an option
                              </option>
                              {row?.options?.map((option, index) => (
                                <option key={index} value={option._id}>
                                  {option.optionName}
                                </option>
                              ))}
                            </select>
                          )}
                        </TableCell>
                        <TableCell align="left">
                          <input
                            type="text"
                            className="form-control ob-form-text-input "
                            id="checklistRemark"
                            onChange={(e) =>
                              onTextChange(e.target.value, {}, 0, row, j)
                            }
                            value={row?.response?.answer}
                            disabled={row?.editAccess == false}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className="div-checklist-savesubmit">
              {modalData?.editAccess == true && (
                <Button
                  onClick={() => submitData(false)}
                  className="btn-checklist-save"
                >
                  Save
                </Button>
              )}

              {modalData?.editAccess == true && technicalData?.isChecklistSubmitted == false && modalData?.sectionName === 'Engineer Input' && (
                <Button
                  onClick={() => openConrimModdal(true)}
                  className="btn-checklist-savesubmit"
                >
                  Save & Submit
                </Button>
              )}

              {modalData?.editAccess == true && modalData?.sectionName === 'QA Input' && technicalData?.factoryVisitStatus !== 'Visited' && (
                <Button
                  onClick={() => openConrimModdal(true)}
                  className="btn-checklist-savesubmit"
                >
                  Save & Submit
                </Button>
              )}

              {technicalData?.isChecklistSubmitted == true && modalData?.sectionName === 'Engineer Input' && (
                <Button
                  onClick={handleCloseModal}
                  className="btn-checklist-savesubmit"
                >
                  Close
                </Button>
              )}

              {modalData?.sectionName === 'QA Input' && technicalData?.factoryVisitStatus === 'Visited' && (
                <Button
                  onClick={handleCloseModal}
                  className="btn-checklist-savesubmit"
                >
                  Close
                </Button>
              )}

            </div>
          </Box>
        </Modal>

        <Modal
          open={openfactorytodotModal}
          onClose={() => closeUploadModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="react_sucess_modal_listing">
            <div className="modal-header">
              <h5 className="modal-title" id="contactModalLabel">
                {uploadObj?.row?.name}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeUploadModal(false)}
              ></button>
            </div>
            <div className="text-center">
              {uploadObj?.param == true && (
                <div className="row">
                  {uploadObj?.row?.editAccess == true && (
                    <div className="col lets_onboarding_wizard_react">
                      <div className="">
                        <div className="mb-3 upload-sec-files">
                          <input
                            className="form-control form-h choose"
                            type="file"
                            id="checklist-fileInput"
                            multiple={false}
                            onChange={addFile}
                          />
                          <Button
                            onClick={uploadFile}
                            className="btn upload_block btn-checklist-file-upload"
                          >
                            Upload
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col lets_onboarding_wizard_react"></div>
                </div>
              )}
              <div className="modal-body download-list-modal">
                <form id="employeeForm">
                  {uploadObj?.row?.response?.files?.length > 0 ? (
                    <>
                      <table className="table" id="employeeTable">
                        <thead className="">
                          <tr>
                            <th className="vendor_tabels">S.No.</th>
                            <th className="vendor_tabels">Document Name</th>
                            <th className="vendor_tabels">Preview</th>
                            {rolesWithPermissions.includes(roleName) && (
                              <>
                                <th className="vendor_tabels">Download</th>
                                {uploadObj?.param == true && (
                                  <th className="vendor_tabels">Delete</th>
                                )}
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {uploadObj?.row?.response?.files?.map(
                            (ele, index) => (
                              <tr key={index}>
                                <td className="maine_tr_vendors">
                                  {index + 1}
                                </td>
                                <td className="maine_tr_vendors">
                                  {isEmptyDash(ele?.name)
                                    ? getFileNameByPath(ele?.key)
                                    : ele?.name}
                                </td>
                                <td className="maine_tr_vendors" style={{ cursor: "pointer" }}>
                                  <PreviewDoc
                                    data={ele}
                                    viewMedia={viewMedia}
                                  />
                                </td>
                                {rolesWithPermissions.includes(roleName) && (
                                  <>
                                    <td className="maine_tr_vendors" style={{ cursor: "pointer" }}>
                                      <FileDownloadIcon
                                        className="remove_icon_react_block_body"
                                        onClick={() => viewMedia(ele?.key)}
                                      />
                                    </td>
                                    {uploadObj?.param == true && (
                                      <td>
                                        <DeleteOutlineIcon
                                          className="delete_icon_react_block_body"
                                          onClick={() => deleteFile(ele, index)}
                                        />
                                      </td>
                                    )}
                                  </>
                                )}
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <div>No data found</div>
                  )}
                </form>
              </div>
            </div>
          </Box>
        </Modal>

        <ConfirmModal
          isConfirmModalOpen={isConfirmModalOpen}
          closeConfirmModal={closeConfirmModal}
          successConfirmModal={successConfirmModal}
          modalMsg="Would you like to confirm your action?"
          closeText="Discard"
        />
        <AlertComponent
          alertComponent={alertComponent}
          handleClose={handleCloseLoader}
        />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div >
    </>
  );
}

export default TechnicalComplianceStep3;
